import { Box, Typography } from "@mui/material";
import LinkRouter from "components/navigation/LinkRouter";

interface TaskSummaryProps {
  planUtilization: any;
}

const TaskSummary = ({ planUtilization }: TaskSummaryProps) => {
  return (
    <Box
      sx={{
        height: "83px",
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        gap: "16px",
      }}
    >
      <LinkRouter
        to={"/tasks"}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          backgroundColor: "#FEF8F5",
          borderRadius: "8px",
          padding: "16px 24px",
          width: "50%",
          cursor: "pointer",
        }}
      >
        <Typography variant="title">
          {planUtilization?.allTimeTasksCompleted || 0}
        </Typography>
        <Typography variant="bodySmall">completed tasks</Typography>
      </LinkRouter>
      <LinkRouter
        to={"/tasks"}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          backgroundColor: "#FEF8F5",
          borderRadius: "8px",
          padding: "16px 24px",
          width: "50%",
          cursor: "pointer",
        }}
      >
        <Typography variant="title">
          {planUtilization?.tasksInProgress || 0}
        </Typography>
        <Typography variant="bodySmall">open tasks</Typography>
      </LinkRouter>
    </Box>
  );
};

export default TaskSummary;
